/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organization_Signup_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter organization name..." |
*
* @param {Organization_Signup_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const organization_signup_name_placeholder = /** @type {((inputs?: Organization_Signup_Name_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organization_Signup_Name_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gib den Namen der Organisation ein...")
	return /** @type {LocalizedString} */ ("Enter organization name...")
});